<template>
	<div class="lightbox">
		<div class="lightbox__window">
			<button class="lightbox__close" @click="handleCancel">
				<img class="lightbox__close-icon" :src="require(`@/assets/images/close.svg`)" />
			</button>
			<div class="lightbox__header">
				<slot name="header"></slot>
			</div>
			<div class="lightbox__body">
				<slot name="body"></slot>
			</div>
			<div class="lightbox__footer">
				<slot name="footer"></slot>

				<Button type="text" value="Отмена" paint="gray" action="cancel" :disabled="false" @click="handleCancel" />
			</div>
		</div>
	</div>
</template>

<script>
	import Button from "../components/Button.vue";

	export default {
		name: "lightbox",
		components: {
			Button,
		},
		methods: {
			handleCancel() {
				this.$emit("lgbcancel");
			},
		},
	};
</script>

<style lang="scss">
	.lightbox {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		overflow-y: scroll;
		background-color: rgba(240, 240, 240, 0.8);
		z-index: $zIndexLightbox;
		padding: 50px 0;

		&__window {
			@include base;

			position: relative;
			width: calc(100% - 60px);
			margin: 0 auto;
			padding: 20px;

			@include mediaquery(sm) {
				width: 400px;
				padding: 50px;
			}
		}

		&__close {
			position: absolute;
			top: 25px;
			right: 25px;
			display: flex;
			border: 0;
			background: none;
			padding: 0;
			cursor: pointer;
		}

		&__header {
			font-weight: 500;
			font-size: 14px;
			color: #2b1a0a;
			text-align: center;
		}

		&__body {
			font-size: 14px;
			margin: 20px 0;
			color: #2b1a0a;
			text-align: center;
			position: relative;
		}

		&__preloader {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			background-color: rgba(240, 240, 240, 0.8);
			z-index: $zIndexLightbox + 100;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		&__block {
			margin-bottom: 10px;
			width: 100%;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			position: relative;

			&[data-kind="triple"] {
				.lightbox__subblock {
					width: calc(33.333333% - 8px);
				}
			}

			&[data-kind="setup"] {
				.lightbox__subblock {
					width: 100%;
					margin-bottom: 10px;

					&:last-of-type {
						margin-bottom: 0;
					}

					input {
						margin-right: 10px;
					}
				}
			}

			&[data-kind="module"] {
				align-items: flex-end;
				.lightbox__subblock {
					width: calc(50% - 28px);
				}
			}

			&[data-kind="file"] {
				align-items: flex-end;
				
				.lightbox__subblock {
					width: calc(100% - 46px);
				}
			}
		}

		&__subblock {
			width: calc(50% - 5px);
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
		}

		&__title {
			font-size: 9px;
			margin-bottom: 6px;
			color: #9b9b9b;
		}

		&__error {
			position: absolute;
			left: 0;
			top: 100%;
			font-size: 9px;
			color: #ff8068;
		}

		&__footer {
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			button {
				width: 100%;
				margin-bottom: 10px;

				&:last-of-type {
					margin-bottom: 0;
				}
			}

			@include mediaquery(sm) {
				flex-direction: row;

				button {
					margin-bottom: 0;

					&:first-of-type {
						width: 180px;
					}

					&:last-of-type {
						width: 110px;
					}

					&:only-child {
						width: 100%;
					}
				}
			}
		}
	}
</style>
